/** Client's Endpoints */
export const CLIENT_ENDPOINTS = {
    TEMPLATES: '/1/templates',
    TEMPLATE: '/1/template',
    DOCUMENTS: '/2/documents',
    DOCUMENT: '/2/document',
    CHAT: '/3/chat',
    PROJECT: '/4/project',
    DESIGNER: '/5/photographer',
    SETTINGS: '/settings',
    SIGN_IN: '/sign-in',
    VERIFY_MAGIC_LINK: '/verify-magic-link',
    BRAND_VOICE: '/6/brand-voice',
    INFOBASE: '/7/infobase',
};
